// //@ts-nocheck
// "use client";

// import { useEffect, useRef, useState } from 'react';
// import BannerHeadline from '../atoms/banner-headline';
// import VideoEmbed from '../atoms/video-embed';
// import styles from './cxa-content.module.css';
// import clsx from 'clsx';
// import { useTheme } from '../../utils/theme';
// import Description from '../atoms/description';
// import Socials from '../atoms/social';
// import Slider from '../atoms/slider';
// import { slugBuilder } from '../../utils/slug-builder';
// import Link from 'next/link';

// // export default function CXAContent({ currentCXA, all = [] }) {
// //     const [isMobile, setIsMobile] = useState(false);

// //     const sortedCXAHub = (all || []).slice().sort((a, b) => {
// //         return a.episode - b.episode;
// //     });
// //     const prevWidth = useRef(window.innerWidth);

// //     const checkScreenSize = () => {
// //         const currentWidth = window.innerWidth;
// //         setIsMobile(currentWidth <= 768);

// //         if (prevWidth.current !== currentWidth || prevWidth.current === undefined) {
// //             prevWidth.current = currentWidth;
// //         }
// //     };
// //     useEffect(() => {
// //         checkScreenSize(); // ✅ Run once on initial mount
// //         window.addEventListener("resize", checkScreenSize);
// //         return () => window.removeEventListener("resize", checkScreenSize);
// //     }, []);

// //     const { theme } = useTheme();

// //     const darkMode = theme === "dark";
// //     const Author = () => {
// //         return (
// //             <div className={styles['author-details']}>
// //                 {currentCXA?.speakerImage ? (
// //                     <div
// //                         className={styles['author-img']}
// //                         style={{ borderRadius: '999999px' }}
// //                     >
// //                         <Slider imageList={[currentCXA?.speakerImage]} />
// //                     </div>
// //                 ) : (
// //                     <div
// //                         className={styles['author-img']}
// //                         style={{ borderRadius: 0 }}
// //                     >
// //                         <img
// //                             src="/VXI-SVG.svg"
// //                             alt="Author"
// //                             style={{ borderRadius: 0, fill: '#FF6D10' }}
// //                         />
// //                     </div>
// //                 )}
// //                 <div className="sectionName">
// //                     <a
// //                         href=""
// //                         rel="noopener noreferrer"
// //                     >
// //                         <b><u>{currentCXA?.speakerFullName}</u></b>
// //                     </a>
// //                     {currentCXA?.speakerTitle && <div>{currentCXA?.speakerTitle}</div>}
// //                     {currentCXA?.speakerLink && <Socials attr={{ socialTypes: 'linkedin', socialLink: currentCXA?.speakerLink }} />}
// //                 </div>
// //             </div>
// //         )
// //     }
// //     return (
// //         <div className={styles.container}>
// //             <div className={clsx(styles["main-video"], !darkMode && styles.light)}>
// //                 <VideoEmbed url={currentCXA?.embedMedia} width={isMobile ? "95vw" : "55vw"} />
// //             </div>
// //             <div className={styles["details"]}>
// //                 <div className={styles["title-desc"]}>
// //                     {currentCXA?.title && <BannerHeadline title={currentCXA?.title} />}
// //                     {currentCXA?.speakerFullName && (
// //                         <Author />
// //                     )}
// //                     {currentCXA?.description && (
// //                         <div className={styles.desc}>
// //                             <div><Description description={currentCXA?.description} mode="blog"/></div>
// //                             <span className="sectionName">Description:</span>
// //                         </div>

// //                     )}
// //                 </div>
// //                 <div className={styles["insight"]}>
// //                     {currentCXA?.insights && (
// //                         <>
// //                         <div><Description description={currentCXA?.insights} mode="blog"/></div>
// //                         <span className="sectionName">Insights:</span>
// //                         </>
// //                     )}
// //                 </div>
// //             </div>
// //             <div className={styles["ghost-wrapper"]}>
// //                     <div className={styles["next-wrapper"]}>
// //                         <div>Up next</div>
// //                         <div className={styles["next-list"]}>
// //                             {all && sortedCXAHub.map((next, index) => (
// //                                 <div key={index} className={styles["next-item"]}>
// //                                     <div className={styles["next-vid"]}>
// //                                         <VideoEmbed url={next.embedMedia} view='view' />
// //                                     </div>
// //                                     <div className={styles["next-deets"]}>
// //                                         <div>
// //                                             <div className={styles["next-title"]}>{next.title}</div>
// //                                             <div className={styles["next-desc"]}>{next.cardDescription}</div>
// //                                         </div>
// //                                         <div>
// //                                             <div className={styles["next-videoLength"]}>{next.videoLength}</div>
// //                                             <div className={styles["next-desc"]}>{next.speakerFullName}</div>
// //                                         </div>
// //                                     </div>
// //                                 </div>
// //                             ))}
// //                         </div>
// //                     </div>
// //                     <div>ghost</div>
// //             </div>
// //         </div>
// //     )
// // }
// export default function CXAContent({ currentCXA, all = [] }) {
//     const [isMobile, setIsMobile] = useState(false);

//     const sortedCXAHub = (all || []).slice().sort((a, b) => a.episode - b.episode);

//     const prevWidth = useRef(typeof window !== 'undefined' ? window.innerWidth : 0);

//     const checkScreenSize = () => {
//         const currentWidth = window.innerWidth;
//         setIsMobile(currentWidth <= 768);
//         if (prevWidth.current !== currentWidth || prevWidth.current === undefined) {
//             prevWidth.current = currentWidth;
//         }
//     };
//     useEffect(() => {
//         checkScreenSize();
//         window.addEventListener('resize', checkScreenSize);
//         return () => window.removeEventListener('resize', checkScreenSize);
//     }, []);

//     const { theme } = useTheme();
//     const darkMode = theme === 'dark';

//     const listRef = useRef(null);
//     const itemRefs = useRef([]);

//     useEffect(() => {
//         if (!currentCXA || !listRef.current) return;

//         const index = sortedCXAHub.findIndex(x => x.episode === currentCXA.episode);
//         // if you want to scroll to the *next* episode:
//         const targetIndex = index + 1;

//         if (targetIndex !== -1 && itemRefs.current[targetIndex]) {
//             const container = listRef.current;
//             const target = itemRefs.current[targetIndex];

//             // Compute offset of target relative to container
//             const offsetTop = target.offsetTop - container.offsetTop;

//             container.scrollTo({
//                 top: offsetTop,
//                 behavior: 'smooth'
//             });
//         }
//     }, [currentCXA, sortedCXAHub]);

//     const Author = () => (
//         <div className={styles['author-details']}>
//             {currentCXA?.speakerImage ? (
//                 <div className={styles['author-img']} style={{ borderRadius: '999999px', border: '4px solid transparent', background: `linear-gradient(transparent 0 0) padding-box, linear-gradient(to bottom, #ff6d10, ${darkMode ? '#4a230bff' : "#f39c66ff"}) border-box` }}>
//                     <Slider imageList={[currentCXA?.speakerImage]} />
//                 </div>
//             ) : (
//                 <div className={styles['author-img']} style={{ borderRadius: 0 }}>
//                     <img src="/VXI-SVG.svg" alt="Author" style={{ borderRadius: 0, fill: '#FF6D10' }} />
//                 </div>
//             )}
//             <div className="sectionName">
//                 <a
//                     href="#"
//                     onClick={(e) => e.preventDefault()}
//                     style={{ pointerEvents: 'none', textDecoration: 'none', fontWeight: 'bold', color: 'inherit' }}
//                 >
//                     {currentCXA?.speakerFullName}
//                 </a>
//                 {currentCXA?.speakerTitle && <div>{currentCXA?.speakerTitle}</div>}
//                 {currentCXA?.speakerLink && (
//                     <Socials attr={{ socialTypes: 'linkedin', socialLink: currentCXA?.speakerLink }} />
//                 )}
//             </div>
//         </div>
//     );

//     return (
//         <div className={styles.container}>
//             <div className={clsx(styles['main-video'], !darkMode && styles.light)}>
//                 <VideoEmbed url={currentCXA?.embedMedia} width={isMobile ? '95vw' : '70vw'} />
//             </div>
//             <div className={styles['details']}>
//                 <div className={styles['title-desc']}>
//                     {currentCXA?.title && <BannerHeadline title={currentCXA?.title} />}
//                     {currentCXA?.speakerFullName && <Author />}
//                     {currentCXA?.description && (
//                         <div className={clsx(styles.desc, !darkMode && styles.light)}>
//                             <div><Description description={currentCXA?.description} mode="blog" /></div>
//                             <span className="sectionName">Description:</span>
//                         </div>
//                     )}
//                 </div>
//                 <div className={styles['insight']}>
//                     {currentCXA?.insights && (
//                         <>
//                             <div><Description description={currentCXA?.insights} mode="blog" /></div>
//                             <span className="sectionName">Insights:</span>
//                         </>
//                     )}
//                 </div>
//             </div>
//             <div className={styles['ghost-wrapper']}>
//                 <div className={styles['next-wrapper']}>
//                     <div>Up next</div>
//                     <div className={styles['next-list']} ref={listRef}>
//                         {sortedCXAHub.map((next, index) => (
//                             <div
//                                 key={index}
//                                 ref={el => (itemRefs.current[index] = el)} // store ref
//                                 className={clsx(styles['next-item'], next.episode === currentCXA.episode && styles["current-active"], next.status === "coming soon" && styles.grayed)}
//                             >
//                                 <Link
//                                     href={next.status === "coming soon" ? "#" : `/${slugBuilder("what we think", "cxa hub", next.title)}`}
//                                 >

//                                     <div className={styles['next-vid']}>
//                                         <VideoEmbed url={next.embedMedia} view="view" />
//                                     </div>
//                                     <div className={styles['next-deets']}>
//                                         <div>
//                                             <div className={styles['next-title']}>{next.title}</div>
//                                             <div className={styles['next-desc']}>{next.cardDescription}</div>
//                                         </div>
//                                         <div>
//                                             <div className={styles['next-videoLength']}>{next.status === "coming soon" ? `Coming on ${next.formattedPublishDate}` : next.videoLength}</div>
//                                             <div className={styles['next-desc']}>{next.speakerFullName}</div>
//                                         </div>
//                                     </div>
//                                     {next.episode === currentCXA.episode && <div className={styles["current-label"]}>Current</div>}
//                                 </Link>
//                             </div>
//                         ))}
//                     </div>
//                 </div>
//                 <div></div>
//             </div>
//         </div>
//     );
// }

//@ts-nocheck
"use client";

import { useEffect, useRef, useState } from 'react';
import BannerHeadline from '../atoms/banner-headline';
import VideoEmbed from '../atoms/video-embed';
import styles from './cxa-content.module.css';
import clsx from 'clsx';
import { useTheme } from '../../utils/theme';
import Description from '../atoms/description';
import Socials from '../atoms/social';
import Slider from '../atoms/slider';
import { slugBuilder } from '../../utils/slug-builder';
import Link from 'next/link';

// export default function CXAContent({ currentCXA, all = [] }) {
//     const [isMobile, setIsMobile] = useState(false);

//     const sortedCXAHub = (all || []).slice().sort((a, b) => {
//         return a.episode - b.episode;
//     });
//     const prevWidth = useRef(window.innerWidth);

//     const checkScreenSize = () => {
//         const currentWidth = window.innerWidth;
//         setIsMobile(currentWidth <= 768);

//         if (prevWidth.current !== currentWidth || prevWidth.current === undefined) {
//             prevWidth.current = currentWidth;
//         }
//     };
//     useEffect(() => {
//         checkScreenSize(); // ✅ Run once on initial mount
//         window.addEventListener("resize", checkScreenSize);
//         return () => window.removeEventListener("resize", checkScreenSize);
//     }, []);

//     const { theme } = useTheme();

//     const darkMode = theme === "dark";
//     const Author = () => {
//         return (
//             <div className={styles['author-details']}>
//                 {currentCXA?.speakerImage ? (
//                     <div
//                         className={styles['author-img']}
//                         style={{ borderRadius: '999999px' }}
//                     >
//                         <Slider imageList={[currentCXA?.speakerImage]} />
//                     </div>
//                 ) : (
//                     <div
//                         className={styles['author-img']}
//                         style={{ borderRadius: 0 }}
//                     >
//                         <img
//                             src="/VXI-SVG.svg"
//                             alt="Author"
//                             style={{ borderRadius: 0, fill: '#FF6D10' }}
//                         />
//                     </div>
//                 )}
//                 <div className="sectionName">
//                     <a
//                         href=""
//                         rel="noopener noreferrer"
//                     >
//                         <b><u>{currentCXA?.speakerFullName}</u></b>
//                     </a>
//                     {currentCXA?.speakerTitle && <div>{currentCXA?.speakerTitle}</div>}
//                     {currentCXA?.speakerLink && <Socials attr={{ socialTypes: 'linkedin', socialLink: currentCXA?.speakerLink }} />}
//                 </div>
//             </div>
//         )
//     }
//     return (
//         <div className={styles.container}>
//             <div className={clsx(styles["main-video"], !darkMode && styles.light)}>
//                 <VideoEmbed url={currentCXA?.embedMedia} width={isMobile ? "95vw" : "55vw"} />
//             </div>
//             <div className={styles["details"]}>
//                 <div className={styles["title-desc"]}>
//                     {currentCXA?.title && <BannerHeadline title={currentCXA?.title} />}
//                     {currentCXA?.speakerFullName && (
//                         <Author />
//                     )}
//                     {currentCXA?.description && (
//                         <div className={styles.desc}>
//                             <div><Description description={currentCXA?.description} mode="blog"/></div>
//                             <span className="sectionName">Description:</span>
//                         </div>

//                     )}
//                 </div>
//                 <div className={styles["insight"]}>
//                     {currentCXA?.insights && (
//                         <>
//                         <div><Description description={currentCXA?.insights} mode="blog"/></div>
//                         <span className="sectionName">Insights:</span>
//                         </>
//                     )}
//                 </div>
//             </div>
//             <div className={styles["ghost-wrapper"]}>
//                     <div className={styles["next-wrapper"]}>
//                         <div>Up next</div>
//                         <div className={styles["next-list"]}>
//                             {all && sortedCXAHub.map((next, index) => (
//                                 <div key={index} className={styles["next-item"]}>
//                                     <div className={styles["next-vid"]}>
//                                         <VideoEmbed url={next.embedMedia} view='view' />
//                                     </div>
//                                     <div className={styles["next-deets"]}>
//                                         <div>
//                                             <div className={styles["next-title"]}>{next.title}</div>
//                                             <div className={styles["next-desc"]}>{next.cardDescription}</div>
//                                         </div>
//                                         <div>
//                                             <div className={styles["next-videoLength"]}>{next.videoLength}</div>
//                                             <div className={styles["next-desc"]}>{next.speakerFullName}</div>
//                                         </div>
//                                     </div>
//                                 </div>
//                             ))}
//                         </div>
//                     </div>
//                     <div>ghost</div>
//             </div>
//         </div>
//     )
// }
import { useRouter } from "next/navigation";
import Title from '../atoms/title';
import { PiCaretLeftBold, PiCaretRightBold } from 'react-icons/pi';

function BackButton() {
    const router = useRouter();

    return (
        <button onClick={() => router.back()}>
            <PiCaretLeftBold />
        </button>
    );
}
export default function CXAContent({ currentCXA, all = [] }) {
    const [isMobile, setIsMobile] = useState(false);
    // useEffect(() => {
    //     console.log("Current CXA:", currentCXA);
    // }, [])
    const sortedCXAHub = (all || [])
        .slice()
        .sort((a, b) => a.episode - b.episode)
        .filter(item =>
            item.series?.[0] === currentCXA?.series?.[0]
        );

    const prevWidth = useRef(typeof window !== 'undefined' ? window.innerWidth : 0);

    const checkScreenSize = () => {
        const currentWidth = window.innerWidth;
        setIsMobile(currentWidth <= 768);
        if (prevWidth.current !== currentWidth || prevWidth.current === undefined) {
            prevWidth.current = currentWidth;
        }
    };
    useEffect(() => {
        checkScreenSize();
        window.addEventListener('resize', checkScreenSize);
        return () => window.removeEventListener('resize', checkScreenSize);
    }, []);

    const { theme } = useTheme();
    const darkMode = theme === 'dark';

    const listRef = useRef(null);
    const itemRefs = useRef([]);

    useEffect(() => {
        if (!currentCXA || !listRef.current) return;

        const index = sortedCXAHub.findIndex(x => x.episode === currentCXA.episode);
        // if you want to scroll to the *next* episode:
        const targetIndex = index + 1;

        if (targetIndex !== -1 && itemRefs.current[targetIndex]) {
            const container = listRef.current;
            const target = itemRefs.current[targetIndex];

            // Compute offset of target relative to container
            const offsetTop = target.offsetTop - container.offsetTop;

            container.scrollTo({
                top: offsetTop,
                behavior: 'smooth'
            });
        }
    }, [currentCXA, sortedCXAHub]);

    const Author = () => (
        <div className={styles['author-details']}>
            {currentCXA?.speakerImage ? (
                <div className={styles['author-img']} style={{ borderRadius: '999999px', border: '4px solid transparent', background: `linear-gradient(transparent 0 0) padding-box, linear-gradient(to bottom, #ff6d10, ${darkMode ? '#4a230bff' : "#f39c66ff"}) border-box` }}>
                    <Slider imageList={[currentCXA?.speakerImage]} />
                </div>
            ) : (
                <div className={styles['author-img']} style={{ borderRadius: 0 }}>
                    <img src="/VXI-SVG.svg" alt="Author" style={{ borderRadius: 0, fill: '#FF6D10' }} />
                </div>
            )}
            <div className="sectionName">
                <a
                    href="#"
                    onClick={(e) => e.preventDefault()}
                    style={{ pointerEvents: 'none', textDecoration: 'none', fontWeight: 'bold', color: 'inherit' }}
                >
                    {currentCXA?.speakerFullName}
                </a>
                {currentCXA?.speakerTitle && <div>{currentCXA?.speakerTitle}</div>}
                {currentCXA?.speakerLink && (
                    <Socials attr={{ socialTypes: 'linkedin', socialLink: currentCXA?.speakerLink }} />
                )}
            </div>
        </div>
    );

    return (
        <div className={styles.container}>
            <div className={styles["main-header"]}>
                <div className={styles.crumb}>
                    <Link href={`/${slugBuilder("what we think")}`}>What We Think</Link>
                    <PiCaretRightBold />
                    <Link href={`/${slugBuilder("what we think", "cxa hub")}`}>CXA Hub</Link>
                    <PiCaretRightBold />
                    <Link href="#">{currentCXA?.topics}</Link>
                </div>
                <div className={styles.back}>
                    <BackButton size={52} />
                    {currentCXA?.title && <Title title={currentCXA?.title} />}
                </div>
            </div>

            <div className={clsx(styles['main-video'], !darkMode && styles.light)}>
                <VideoEmbed url={currentCXA?.embedMedia} width={isMobile ? '95vw' : '70vw'} />
            </div>
            <div className={styles['details']}>
                <div className={styles['title-desc']}>
                    {currentCXA?.speakerFullName && <Author />}
                    {currentCXA?.description && (
                        <div className={clsx(styles.desc, !darkMode && styles.light)}>
                            <div><Description description={currentCXA?.description} mode="blog" /></div>
                            <h3>Description</h3>
                        </div>
                    )}
                </div>
                {/* <div className={styles['insight']}>
                    {currentCXA?.insights && (
                        <>
                            <div><Description description={currentCXA?.insights} mode="blog" /></div>
                            <span className="sectionName">Insights:</span>
                        </>
                    )}
                </div> */}
            </div>
            <div className={styles['ghost-wrapper']}>
                <div className={styles['next-wrapper']}>
                    <h3>Up next</h3>
                    <div className={styles['next-list']} ref={listRef}>
                        {sortedCXAHub.map((next, index) => (
                            <div
                                key={index}
                                ref={el => (itemRefs.current[index] = el)} // store ref
                                className={clsx(styles['next-item'], next.episode === currentCXA.episode && styles["current-active"], next.status === "coming soon" && styles.grayed)}
                            >
                                <Link
                                    href={next.status === "coming soon" ? "#" : `/${slugBuilder("what we think", "cxa hub", next.title)}`}
                                >

                                    <div className={styles['next-vid']}>
                                        <VideoEmbed url={next.embedMedia} view="view" />
                                    </div>
                                    <div className={styles['next-deets']}>
                                        <div>
                                            <h2 className={styles['next-title']}>{next.title}</h2>
                                            <div className={styles['next-desc']}>{next.cardDescription}</div>
                                        </div>
                                        <div>
                                            <div className={styles['next-videoLength']}>{next.status === "coming soon" ? `Coming on ${next.formattedPublishDate}` : next.videoLength}</div>
                                            <div className={styles['next-desc']}>{next.speakerFullName}</div>
                                        </div>
                                    </div>
                                    {next.episode === currentCXA.episode && <div className={styles["current-label"]}>Current</div>}
                                </Link>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
}
